var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEgg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 400 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M343.017 91.564c-18.441-27.817-39.65-49.901-63.037-65.638C254.414 8.722 227.505 0 200.001 0c-27.506 0-54.414 8.722-79.98 25.926-23.389 15.737-44.597 37.821-63.038 65.638C20.77 146.189 0 215.878 0 282.764c0 65.656 20.228 121.091 58.497 160.312C94.314 479.784 144.569 500 200.001 500c55.432 0 105.684-20.216 141.502-56.925C379.772 403.854 400 348.42 400 282.764c0-66.886-20.77-136.575-56.983-191.2zM323.245 425.03c-30.967 31.737-74.736 49.215-123.244 49.215-48.509 0-92.278-17.479-123.246-49.215-33.472-34.305-51.165-83.5-51.165-142.266 0-61.926 19.201-126.406 52.679-176.905C112.515 54.203 155.745 25.756 200 25.756c44.254 0 87.486 28.447 121.73 80.103 33.478 50.5 52.679 114.979 52.679 176.905.001 58.766-17.693 107.961-51.164 142.266zM212.794 56.219c0 7.112-5.728 12.877-12.795 12.877-28.972 0-60.284 22.167-85.907 60.818-2.466 3.719-6.523 5.731-10.655 5.731-2.441 0-4.908-.701-7.09-2.167-5.879-3.947-7.465-11.943-3.543-17.859 30.452-45.934 69.523-72.277 107.194-72.277 7.068-.001 12.796 5.764 12.796 12.877z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgg);
export default __webpack_public_path__ + "static/media/egg.8a501e7c323d3bc8d9c7c69d85f58a5c.svg";
export { ForwardRef as ReactComponent };